import { createFileRoute, redirect } from '@tanstack/react-router'
import CheckoutPage from '@/spa/pages/CheckoutPage'
import { canShowPurchaseUi } from '@/lib/purchase-surface'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/checkout/')({
  // Web only — a purchase screen inside the native binary defeats the App
  // Review carve-outs the app relies on. See canShowPurchaseUi().
  beforeLoad: () => {
    if (!canShowPurchaseUi()) throw redirect({ to: '/' })
  },
  component: CheckoutPage,
  errorComponent: routeErrorComponent,
})
